// extracted by mini-css-extract-plugin
export default {"color-hot-tamales":"#F9302D","colorHotTamales":"#F9302D","color-hot-tamales-10":"rgba(249, 48, 45, 0.1)","colorHotTamales10":"rgba(249, 48, 45, 0.1)","label":"_152ai"};